'use client'

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { WikiRoutedPage } from './deskUi/WikiRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function WikiSurfaceClient(props: DeskSurfaceClientProps) {
  return (
    <MsgDeskSurfaceClient
      {...props}
      RoutedPage={WikiRoutedPage}
      Loading={MsgDeskLoading}
      loadInitialSubsOnMsgRoute={false}
    />
  )
}
